export function DistributorLocation({
    locationId,
    locationName,
    adminEmail,
    hasPremiumPlan,
    hasGuestIncidentsLicense,
    numUsers,
    invitationsTotal,
    invitationsAvailable,
    activeLicenseNames,
    adminEmails,
    devices,
    licenses,
} = {}) {
    return {
        locationId,
        locationName,
        adminEmail,
        hasPremiumPlan,
        hasGuestIncidentsLicense,
        numUsers,
        invitationsTotal,
        invitationsAvailable,
        activeLicenseNames,
        adminEmails,
        devices,
        licenses,
    };
}
